const fields = [
	{name: "comment", label: "Написать комментарий", type: "text", required: true},
];

const initialValues = {
	comment: '',
};

export {fields, initialValues};